// extracted by mini-css-extract-plugin
export var orderSummary = "_sz-0";
export var showMoreLessButton = "_sz-1";